var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCart)?_c('div',{staticClass:"continue_box"},[_vm._m(0),_c('div',{staticClass:"box_btn"},[_c('div',{on:{"click":_vm.fnNext}},[_vm._v("이어하기")])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box_text"},[_c('p',[_c('strong',[_vm._v("안전도 리포트 신청 중")])]),_c('p',[_vm._v("주소를 입력해 주세요")])])
}]

export { render, staticRenderFns }